import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { selectMemberInstance } from 'affiny-core/redux/selectors/membersSelectors';
import { selectMainPictureIdByAccountId } from 'affiny-core/redux/selectors/picturesSelectors';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  getCompatibilityReportLight,
  getMemberProfile,
} from '../api/repositories/member/member.sagas';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import { getPicturesAction } from '../pictures/actions';
import { getPicturesSaga } from '../pictures/saga';
import {
  EMembersProfileActionType,
  getCompatibilityReportLightSuccess,
  getMemberProfileAction,
  getMemberProfileSuccessAction,
  IGetCompatibilityReportLight,
  IGetMemberProfileAction,
} from './actions';

export function* getMemberProfileSaga(action: IGetMemberProfileAction) {
  const response = yield call(
    getMemberProfile,
    action.payload.accountId,
    action.payload.includes
  );

  yield put(getMemberProfileSuccessAction(response));
}

export function* getMemberWithMainPicture(receiverAboId: string) {
  if (!(yield* checkHasCompletedProfile())) return;

  const receiver = yield select(selectMemberInstance, receiverAboId);

  if (!receiver) {
    yield call(
      getMemberProfileSaga,
      getMemberProfileAction({ accountId: receiverAboId, includes: [] })
    );
  }

  let mainPictureId: string | undefined = yield select(
    selectMainPictureIdByAccountId,
    receiverAboId
  );

  if (!mainPictureId) {
    yield call(getPicturesSaga, getPicturesAction(receiverAboId));
    mainPictureId = yield select(selectMainPictureIdByAccountId, receiverAboId);
  }

  return { mainPicture: mainPictureId };
}

export function* getCompatibilityReportLightSaga(
  action: IGetCompatibilityReportLight
) {
  if (!(yield* checkHasCompletedProfile())) return;

  const response = yield call(
    getCompatibilityReportLight,
    action.payload.accountId
  );

  yield put(getCompatibilityReportLightSuccess(response));
}

export function* membersRootSaga() {
  yield all([
    takeLatest(
      EMembersProfileActionType.GET,
      handleAsyncStatus(
        getMemberProfileSaga,
        EAsyncEventTypes.AFFINY_MATCH_LIST_ANNOUNCE
      )
    ),
  ]);
  yield all([
    takeLatest(
      EMembersProfileActionType.GET_COMPATIBILITY_REPORT_LIGHT,
      handleAsyncStatus(
        getCompatibilityReportLightSaga,
        EAsyncEventTypes.GET_COMPATIBILITY_REPORT_LIGHT
      )
    ),
  ]);
}
